
import Confirm from 'vux/src/components/confirm/index.vue'

import { getAssignList, isWorker, deleteList } from '@/api/mamixiaowu'
import { getCity, getCounty } from '@/api/sys.js'
export default {
components: {
Confirm
},
data () {
return {
id: 0,
accountidNAME: '',
mete_list: [],
sourcetype: 1,
page: 1,
rows: 10,
Auth: [],
provinceid: 0,
cityid: '',
countyid: '',
auth: '',
areatype: 0,
areatypeNAME: '',
confirm_delete: false,
show_confirm: false,
listOfdelete: '',
cityList: [],
countyList: [],
searchAreatype: '',
nomore: false,
moremsg: '点击加载更多'
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
created () {
this.isWorkerNow()
this.getCityList()
},
methods: {
isWorkerNow () {
isWorker({
accountid: this.accountid,
sourcetype: this.sourcetype
}).then(data => {


this.auth = data.returnValue.auth
this.areatype = data.returnValue.areatype
this.getAssignListNow()
})
},

getAssignListNow () {
if (this.cityid === '' && this.countyid === '') {
this.searchAreatype = ''
} else if (this.cityid === '0' && this.countyid === '') {
this.searchAreatype = '1'
} else if (this.cityid !== '' && this.cityid !== '0' && this.countyid === '') {
this.searchAreatype = '3'
} else if (this.cityid !== '' && this.cityid !== '0' && this.countyid === '0') {
this.searchAreatype = '4'
} else if (this.cityid !== '' && this.cityid !== '0' && this.countyid !== '' && this.countyid !== '0') {
this.searchAreatype = '5'
}
getAssignList({
accountid: this.accountid,
sourcetype: this.sourcetype,

page: this.page,
rows: this.rows,
accountidNAME: this.accountidNAME,
areatype: this.searchAreatype,
cityid: this.cityid,
countyid: this.countyid
}).then(data => {
console.log(data.returnValue.list.length)
if (data.returnValue.list.length > 0) {
this.mete_list = [...this.mete_list, ...data.returnValue.list]
this.id = data.returnValue.list.id
this.moremsg = '点击加载更多'
} else {
this.moremsg = '没有更多了'
this.nomore = true
}
})
console.log(this.mete_list)
},
loadmore () {
if (!this.nomore) {
this.moremsg = '正在加载中...'
this.page++
this.getAssignListNow()
}
},
clear () {
this.accountidNAME = ''
this.cityid = ''
this.countyid = ''
this.countyList = []
this.getAssignListNow()
},

delete_list (mete_item) {
this.listOfdelete = mete_item
this.show_confirm = true
},

modify_list (mete_item) {
this.$router.push({ path: '/mamixiaowu/modify', query: mete_item })
},
onConfirm () {
this.confirm_delete = true
this.deleteall()
},
deleteall () {
deleteList({
accountid: this.accountid,
sourcetype: this.sourcetype,
ids: this.listOfdelete.id
}).then(function () { location.reload() })
},
getCityList () {
getCity({ plistvalue: '31', addTreeNode: 1 }).then(data => {
this.cityList = data.obj
})
},
getCountyList (id) {
this.countyList = []
this.countyList.push({ value: '市本级', key: '0' })
getCounty({ plistvalue: id, addTreeNode: 1 }).then(data => {
this.countyList = [...this.countyList, ...data.obj]
})
},
onChange () {
this.countyid = ''
if (this.cityid !== '' && this.cityid !== '0') {
this.getCountyList(this.cityid)
}
}
}
}
